exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * To be used with CSS Modules rendered by the webpack.config.\n * Any styles specific to the User Answer module should live here.\n * Import as neede like so:\n * ...\n * import userAnswerStyles from 'userAnswerModuleStyles.css';\n * ...\n * render() {\n *   return(\n *     <div styleName=\"user-answer-item\">\n * ...\n */\n\n.modules-userAnswer-___userAnswerModuleStyles__user-answer-item___1dXe1 {\n\n}\n", ""]);

// exports
exports.locals = {
	"user-answer-item": "modules-userAnswer-___userAnswerModuleStyles__user-answer-item___1dXe1"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./modules/userAnswer/userAnswerModuleStyles.css
// module id = 1365
// module chunks = 1